
export const Cultures = {
    EnglishCanada: "en-CA",
    EnglishUnitedKingdom: "en-GB",
    EnglishUnitedStates: "en-US",
    EnglishAustralia: "en-AU",
    FrenchCanada: "fr-CA",
    FrenchFrance: "fr-FR",
    SpanishSpain: "es-ES",
    GermanGermany: "de-DE",
    DutchNetherlands: "nl-NL",
    ItalianItaly: "it-IT",
    PortuguesePortugal: "pt-PT",
    SpanishMexico: "es-MX",
    SpanishLatinAmerica: "es-419",
    StretchEnglish: "en-ZW",
    MicroCodeEnglish: "en-ZA",
    CroatianCroatian: "hr-HR",
    CzechCzech: "cs-CZ",
    DanishDanish: "da-DK",
    FinnishFinish: "fi-FI",
    HungarianHungarian: "hu-HU",
    NorwegianBokmal: "nb-NO",
    NorwegianNynorsk: "nn-NO",
    PolishPolish: "pl-PL",
    SlovakSlovak: "sk-SK",
    SwedishSweden: "sv-SE",
    SimplifiedChinese: "zh-CN",
    JapaneseJapan: "ja-JP"
  } as const;
  
  export type Culture = (typeof Cultures)[keyof typeof Cultures];
  
  export const CultureCodes = Object.values(Cultures);
  
  export enum CulturesInTheirLanguages {
    EnglishCanada = "English (Canada)",
    EnglishUnitedKingdom = "English (UK)",
    EnglishUnitedStates = "English (US)",
    EnglishAustralia = "English (AU)",
    FrenchCanada = "Français (Canada)",
    FrenchFrance = "Français (France)",
    SpanishSpain = "Español (España)",
    GermanGermany = "Deutsch (Deutschland)",
    DutchNetherlands = "Nederlands (Nederland)",
    ItalianItaly = "Italiano (Italia)",
    PortuguesePortugal = "Português (Portugal)",
    SpanishMexico = "Español (México)",
    SpanishLatinAmerica = "Español (América Latina)",
    StretchEnglish = "Stretched English",
    MicroCodeEnglish = "MicroCoded English",
    CroatianCroatian = "Hrvatski (Hrvatska)",
    CzechCzech = "Čeština (Česká republika)",
    DanishDanish = "Dansk (Danmark)",
    FinnishFinish = "Suomi (Suomi)",
    HungarianHungarian = "Magyar (Magyarország)",
    NorwegianBokmal = "Norsk Bokmål (Norge)",
    NorwegianNynorsk = "Norsk Nynorsk (Norge)",
    PolishPolish = "Polski (Polska)",
    SlovakSlovak = "Slovenčina (Slovensko)",
    SwedishSweden = "Svenska (Sverige)",
    SimplifiedChinese = "简体中文 (中国)",
    JapaneseJapan = "日本語 (日本)"
  }